<template>
  <div class="botoes-flutuantes">
    <!-- Botão de Atualização -->
    <!-- <v-btn
      color="orange"
      v-b-tooltip.left
      title="Atualização" 
      style="z-index: 99999999; margin-bottom: 55px;"
      fab
      fixed
      dark
      right
      small
      bottom
      v-if="mostrarBotaoMaximizarAtualizacao"
      @click="$emit('abrirModalAtualizacao')"
    >
      <v-icon>mdi-autorenew</v-icon>
    </v-btn> -->

    <!-- Botão WF1 -->
    <!-- <v-btn
      small
      v-b-tooltip.left
      title="WF1"
      v-if="mostrarBotaoMaximizarWf1"
      color="primary"
      style="z-index: 99999999;"
      fab
      dark
      fixed
      bottom
      right
      class="margin-bottom-100"
      @click="$emit('abrirModalWf1')"
    >
      <v-icon>mdi-calendar-edit-outline</v-icon>
    </v-btn> -->

    <!-- Botão Anotações -->
    <!-- <v-btn
      small
      v-b-tooltip.left
      title="Anotações"
      v-if="mostrarBotaoMaximizarAnotacoes"
      color="primary"
      style="z-index: 99999999;"
      fab
      dark
      fixed
      bottom
      right
      class="margin-bottom-60"
      @click="$emit('abrirModalAnotacoes')"
    >
      <v-icon>mdi-format-list-checks</v-icon>
    </v-btn> -->
  </div>
</template>

<script>
export default {
  name: 'FichaTecnicaBotoesFlutuantes',
  
  props: {
    mostrarBotaoMaximizarAtualizacao: {
      type: Boolean,
      default: false
    },
    mostrarBotaoMaximizarWf1: {
      type: Boolean,
      default: false
    },
    mostrarBotaoMaximizarAnotacoes: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-bottom-60 {
  margin-bottom: 60px;
}

.margin-bottom-100 {
  margin-bottom: 100px;
}
</style>
